var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingInit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(238, 242, 246)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "211px",
    height: "211px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "0.78125s"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8200000000000001,
    fill: "#9f67f8",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1.0416666666666667s"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8200000000000001,
    fill: "#9883fa",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    transform: "rotate(90 50 50)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1.5625s"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8200000000000001,
    fill: "#9299fa",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    transform: "rotate(180 50 50)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "3.125s"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8200000000000001,
    fill: "#8ab9fd",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    transform: "rotate(270 50 50)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingInit);
export default __webpack_public_path__ + "static/media/loading-init.7d6312fe9a21da7c76bd2eb1644c9049.svg";
export { ForwardRef as ReactComponent };